var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsAppScrolsvg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_289_92181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 64L4.5234 47.5742C1.72684 42.7529 0.25979 37.2928 0.275071 31.711C0.275071 14.2205 14.5788 0 32.1375 0C40.6647 0 48.6724 3.30038 54.6781 9.29278C60.6991 15.2852 64.0152 23.2548 64 31.7262C64 49.2167 49.6962 63.4373 32.1222 63.4373H32.1069C26.7736 63.4373 21.532 62.0989 16.871 59.5742L0 64ZM17.681 53.8403L18.6437 54.4183C22.7087 56.8213 27.3696 58.0837 32.1222 58.0989H32.1375C46.7316 58.0989 58.6208 46.2814 58.6208 31.7415C58.6208 24.6996 55.8701 18.0837 50.8729 13.0951C45.8758 8.10647 39.213 5.36882 32.1375 5.36882C17.5434 5.35361 5.65425 17.1711 5.65425 31.711C5.65425 36.6844 7.04488 41.5361 9.70391 45.7339L10.3305 46.7377L7.65615 56.4563L17.681 53.8403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.11328 62.8889L5.48386 47.0257C2.77899 42.387 1.35779 37.1094 1.35779 31.7254C1.37307 14.8432 15.1725 1.10938 32.1352 1.10938C40.3721 1.10938 48.0894 4.30329 53.8964 10.0828C59.7035 15.8622 62.8974 23.5581 62.8974 31.7406C62.8974 48.6227 49.0827 62.3565 32.1352 62.3565H32.1199C26.97 62.3565 21.9117 61.0638 17.4189 58.6303L1.11328 62.8889Z",
    fill: "url(#paint0_linear_289_92181)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 64L4.5234 47.5742C1.72684 42.7529 0.25979 37.2928 0.275071 31.711C0.275071 14.2205 14.5788 0 32.1375 0C40.6647 0 48.6724 3.30038 54.6781 9.29278C60.6991 15.2852 64.0152 23.2548 64 31.7262C64 49.2167 49.6962 63.4373 32.1222 63.4373H32.1069C26.7736 63.4373 21.532 62.0989 16.871 59.5742L0 64ZM17.681 53.8403L18.6437 54.4183C22.7087 56.8213 27.3696 58.0837 32.1222 58.0989H32.1375C46.7316 58.0989 58.6208 46.2814 58.6208 31.7415C58.6208 24.6996 55.8701 18.0837 50.8729 13.0951C45.8758 8.10647 39.213 5.36882 32.1375 5.36882C17.5434 5.35361 5.65425 17.1711 5.65425 31.711C5.65425 36.6844 7.04488 41.5361 9.70391 45.7339L10.3305 46.7377L7.65615 56.4563L17.681 53.8403Z",
    fill: "url(#paint1_linear_289_92181)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1786 18.4485C23.5826 17.1253 22.9561 17.0949 22.3906 17.0797C21.9322 17.0645 21.3973 17.0645 20.8625 17.0645C20.3276 17.0645 19.4718 17.2622 18.7383 18.053C18.0048 18.8439 15.957 20.7603 15.957 24.669C15.957 28.5626 18.8147 32.3344 19.212 32.8667C19.6094 33.3991 24.7288 41.6576 32.8128 44.8363C39.5368 47.4827 40.9121 46.9504 42.3639 46.8135C43.8157 46.6766 47.0707 44.8972 47.7431 43.0416C48.4002 41.1861 48.4002 39.6044 48.2015 39.2698C48.0029 38.9352 47.468 38.7375 46.6733 38.342C45.8787 37.9466 41.9666 36.0302 41.233 35.7565C40.4995 35.4979 39.9647 35.361 39.4451 36.1519C38.9102 36.9428 37.382 38.7223 36.9236 39.2546C36.4651 39.7869 35.9914 39.8477 35.1968 39.4523C34.4021 39.0569 31.8348 38.2204 28.7937 35.5131C26.425 33.4143 24.8204 30.8135 24.362 30.0226C23.9035 29.2318 24.3161 28.8059 24.7135 28.4105C25.065 28.0607 25.5081 27.4827 25.9054 27.0264C26.3028 26.5702 26.4403 26.2356 26.7001 25.7032C26.9599 25.1709 26.8376 24.7146 26.639 24.3192C26.4403 23.939 24.8816 20.015 24.1786 18.4485Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_289_92181",
    x1: 32.0037,
    y1: 62.8858,
    x2: 32.0037,
    y2: 1.10721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20B038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D66A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_289_92181",
    x1: 32.0062,
    y1: 63.994,
    x2: 32.0062,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_289_92181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsAppScrolsvg);
export default __webpack_public_path__ + "static/media/WhatsAppSCROLSVG.bd612df0602d73855618aec30ea03654.svg";
export { ForwardRef as ReactComponent };